<template>
  <b-modal id="bv-modal-pedidos" size="lg" title="Pedidos" scrollable centered>
    <div class="modal-log">

    <fieldset class="made-up" v-if="this.getlogchat.solicitacao || this.getlogchat.tipo || this.getlogchat.quantidade">
        <legend>Solicitação</legend>
        <div class="row">
			<div class="col-md-12" v-if="this.getlogchat.solicitacao">
				<label for="solicitacao"><strong>Solicitação</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacao" type="text" id="solicitacao" name="solicitacao" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.tipo">
				<label for="malote"><strong>Malote</strong></label>
				<input class="form-control" v-model="this.getlogchat.tipo" type="text" id="malote" name="malote" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.quantidade">
				<label for="quantidade"><strong>Quantidade</strong></label>
				<input class="form-control" v-model="this.getlogchat.quantidade" type="text" id="quantidade" name="quantidade" disabled>
			</div>
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.contato || this.getlogchat.cnpj || this.getlogchat.protocolo || this.getlogchat.created_at">
        <legend>Dados do Atendimento</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.contato">
				<label for="whatsapp"><strong>WhatsAPP</strong></label>
				<input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
				<label for="cnpj"><strong>CNPJ</strong></label>
				<input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
				<label for="protocolo"><strong>Protocolo</strong></label>
				<input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo" name="protocolo" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
				<label for="created_at"><strong>Data</strong></label>
				<input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at" name="created_at" disabled>
			</div>
            
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.RazaoSocialCliente || this.getlogchat.NomeFantasiaCliente || this.getlogchat.nomePonto || this.getlogchat.codigoPonto || this.getlogchat.endereco || this.getlogchat.cep">
        <legend>Dados do Cliente</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.RazaoSocialCliente">
				<label for="RazaoSocialCliente"><strong>Razão Social</strong></label>
				<input class="form-control" v-model="this.getlogchat.RazaoSocialCliente" type="text" id="RazaoSocialCliente" name="RazaoSocialCliente" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.NomeFantasiaCliente">
				<label for="NomeFantasiaCliente"><strong>Nome Fantasia</strong></label>
				<input class="form-control" v-model="this.getlogchat.NomeFantasiaCliente" type="text" id="NomeFantasiaCliente" name="NomeFantasiaCliente" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
				<label for="nomePonto"><strong>Nome do Ponto</strong></label>
				<input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto" name="nomePonto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
				<label for="codigoPonto"><strong>Código do Ponto</strong></label>
				<input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto" name="codigoPonto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
				<label for="endereco"><strong>Endereço</strong></label>
				<input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
				<label for="cep"><strong>CEP</strong></label>
				<input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
			</div>

        </div>
    </fieldset>

    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
            variant="danger"
            class="float-right"
            @click="downloadPdf()"
        >
          Baixar PDF
        </b-button>
      </div>
    </template>

    <VueHtml2pdf
        class="d-none"
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :filename="mensagens"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="modal-log">
        
    <fieldset class="made-up" v-if="this.getlogchat.solicitacao || this.getlogchat.tipo || this.getlogchat.quantidade">
        <legend>Solicitação</legend>
        <div class="row">
			<div class="col-md-12" v-if="this.getlogchat.solicitacao">
				<label for="solicitacao"><strong>Solicitação</strong></label>
				<input class="form-control" v-model="this.getlogchat.solicitacao" type="text" id="solicitacao" name="solicitacao" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.tipo">
				<label for="malote"><strong>Malote</strong></label>
				<input class="form-control" v-model="this.getlogchat.tipo" type="text" id="malote" name="malote" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.quantidade">
				<label for="quantidade"><strong>Quantidade</strong></label>
				<input class="form-control" v-model="this.getlogchat.quantidade" type="text" id="quantidade" name="quantidade" disabled>
			</div>
        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.contato || this.getlogchat.cnpj || this.getlogchat.protocolo || this.getlogchat.created_at">
        <legend>Dados do Atendimento</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.contato">
				<label for="whatsapp"><strong>WhatsAPP</strong></label>
				<input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
				<label for="cnpj"><strong>CNPJ</strong></label>
				<input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
				<label for="protocolo"><strong>Protocolo</strong></label>
				<input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo" name="protocolo" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
				<label for="created_at"><strong>Data</strong></label>
				<input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at" name="created_at" disabled>
			</div>

        </div>
    </fieldset>

    <fieldset class="made-up" v-if="this.getlogchat.RazaoSocialCliente || this.getlogchat.NomeFantasiaCliente || this.getlogchat.nomePonto || this.getlogchat.codigoPonto || this.getlogchat.endereco || this.getlogchat.cep">
        <legend>Dados do Cliente</legend>
        <div class="row">

			<div class="col-md-12" v-if="this.getlogchat.RazaoSocialCliente">
				<label for="RazaoSocialCliente"><strong>Razão Social</strong></label>
				<input class="form-control" v-model="this.getlogchat.RazaoSocialCliente" type="text" id="RazaoSocialCliente" name="RazaoSocialCliente" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.NomeFantasiaCliente">
				<label for="NomeFantasiaCliente"><strong>Nome Fantasia</strong></label>
				<input class="form-control" v-model="this.getlogchat.NomeFantasiaCliente" type="text" id="NomeFantasiaCliente" name="NomeFantasiaCliente" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
				<label for="nomePonto"><strong>Nome do Ponto</strong></label>
				<input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto" name="nomePonto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
				<label for="codigoPonto"><strong>Código do Ponto</strong></label>
				<input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto" name="codigoPonto" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
				<label for="endereco"><strong>Endereço</strong></label>
				<input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco" disabled>
			</div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
				<label for="cep"><strong>CEP</strong></label>
				<input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
			</div>

        </div>
    </fieldset>

       </div>
      </section>
    </VueHtml2pdf>
  </b-modal>
</template>
<script>
import {mapGetters} from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components:{
    VueHtml2pdf
  },

  data:() => ({
    mensagens: 'mensagens_' + window.moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
  }),

  computed:{
    ...mapGetters(['getlogchat'])
  },

  methods:{
    async openModal() {
        this.$bvModal.show('bv-modal-pedidos');
    },

    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    }
  }
}
</script>

<style scoped>
    .modal-log{
        overflow-y: auto;
        overflow-x: hidden;
    }

    .modal-log .espcForm{
        margin: 5px 0px 0px 0px;
    }

    .modal-log label, input, textarea{
        font-size: 12px;
    }
    .made-up{
        font-family: arial;
        margin: 10px;
        border-radius: 10px;
        background: #fff;
        border: solid 1px #9797A6;
        border-radius: 2px;
        padding: 10px;
    }

    .made-up fieldset{
        margin: 5px 30px;
    }

    .made-up legend{
        background: #1C869A; 
        color: #FEFEFE;
        margin: 0px;
        padding: 5px 20px;
        width: auto;
        font-size: 14px;
        border-radius: 2px;
    }

    .avoid-page-break {
      page-break-inside: avoid;
    }
</style>